import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { errorMessage, successMessage } from '~/utils/toasts';
import Axios from '~/utils/axios';
import { Translate } from '~/i18n';
import { CloseIcon } from '~/svgs';
import { Button } from '~/components/common/button';
import Modal from '~/components/common/modal';
import { Section } from '~/components/common/section';
import { SubmitLoader } from '~/components/common/loaders/submit';
import { sentryCaptureException } from '~/errors/sentry';

type UnpublishProductModalType = {
   open: boolean;
   setOpen: (value: boolean) => void;
   productName: string;
   productId: string;
   isUnderReview?: boolean;
   onClose?: (hasStatusChanged?: boolean) => void;
};
const UnpublishProductModal = ({
   open,
   setOpen,
   productName,
   productId,
   isUnderReview,
   onClose,
}: UnpublishProductModalType) => {
   const queryClient = useQueryClient();
   const [loading, setLoading] = useState(false);

   const UnpublishProduct = async () => {
      try {
         setLoading(true);
         const { data } = await Axios.put(`hy-providers/v1/products/${productId}/change-status`, {
            status: 'Draft',
         });
         setLoading(false);
         setOpen(false);
         successMessage(data?.message);
         onClose?.(true);
         queryClient.invalidateQueries(['product', { productId }]);
      } catch (error: any) {
         setLoading(false);
         if (error.response?.status === 403 || error.response?.status === 422) {
            errorMessage(error?.response?.data?.message);
         }
         console.log(error);
         sentryCaptureException(error, { level: 'fatal', tags: { journey: 'business' } });
      }
   };

   return (
      <Modal size="xs" open={open}>
         <Modal.Body>
            <Section className="p-2 rounded-2xl">
               <div
                  onClick={() => {
                     setOpen(false);
                     onClose?.();
                  }}
                  className="flex justify-end w-full cursor-pointer">
                  <CloseIcon />
               </div>
               <div className="flex flex-col items-center px-5 pb-5 text-center">
                  <div className="mb-4 text-2xl font-bold">
                     <Translate
                        id={`productDetails:${
                           isUnderReview ? 'cancel request description' : 'unpublished'
                        }`}
                     />
                  </div>
                  <div className="text-sm">
                     <Translate
                        id={`productDetails:${
                           isUnderReview ? 'withdraw alert' : 'unpublish alert'
                        }`}
                        values={{ productName: productName }}
                     />
                  </div>
                  <div className="flex justify-center mt-8 w-full space-x-2 rtl:space-x-reverse">
                     <Button
                        onClick={() => {
                           setOpen(false);
                           onClose?.();
                        }}
                        theme="outline-primary"
                        className="h-12 text-white w-28 flex-1">
                        <Translate id="common:no" />
                     </Button>
                     <Button
                        onClick={() => UnpublishProduct()}
                        className="h-12 text-white w-28 flex-1 !bg-states-warning ">
                        {loading ? (
                           <SubmitLoader isDotsType color="#ffffff" />
                        ) : (
                           <Translate id="common:yes" />
                        )}
                     </Button>
                  </div>
               </div>
            </Section>
         </Modal.Body>
      </Modal>
   );
};

export default UnpublishProductModal;
